export default function CalcHeader() {
  return (
    <section className="text-center pb-8 border-b border-gray-200">
      <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
        Калькулятор подписки на сервис
      </h1>
      <p className="mt-2 text-sm text-gray-400">
        Рассчитайте стоимость своего пользования сервисом
      </p>
    </section>
  );
}
